import { OCR_MIN_BLOCK_CONFIDENCE } from '../extraction/extractionTypes';
import { OcrBlock } from './ocrTypes';

/*
 * The OCR text rule (PHO-D7): Tesseract's paragraph blocks are kept as they are, except that a
 * block whose confidence is below OCR_MIN_BLOCK_CONFIDENCE is dropped. Nothing else is filtered:
 * no caption, bubble or size rules. Any change to what this keeps bumps OCR_VERSION.
 */

/**
 * Joins the blocks of one image that are confident enough, in their given (reading) order, with a
 * blank line between them. A block at exactly the threshold is kept; blocks that are empty once
 * trimmed are dropped. No blocks, or none kept, gives `''`.
 */
export const keepConfidentBlocks = (blocks: OcrBlock[]): string =>
  blocks
    .filter((block) => block.confidence >= OCR_MIN_BLOCK_CONFIDENCE)
    .map((block) => block.text.trim())
    .filter((text) => text !== '')
    .join('\n\n');
